import { render, staticRenderFns } from "./CvoDetailActivityVisit.vue?vue&type=template&id=317a9968&"
import script from "./CvoDetailActivityVisit.vue?vue&type=script&lang=js&"
export * from "./CvoDetailActivityVisit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports